export default {"src":"/_next/static/media/SpinalDeformities.1c9bc13d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};